import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, isRef as _isRef, vModelRadio as _vModelRadio, withDirectives as _withDirectives, vModelText as _vModelText, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, createBlock as _createBlock, toDisplayString as _toDisplayString, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/img/testing/putt_e_2_0_s.png'
import _imports_1 from '@/assets/img/testing/putt_m_2_0_s.png'
import _imports_2 from '@/assets/img/testing/putt_h_2_0_s.png'
import _imports_3 from '@/assets/img/testing/putt_u_2_0_s.png'
import _imports_4 from '@/assets/img/testing/tocc_e_s.png'
import _imports_5 from '@/assets/img/testing/tocc_h_s.png'
import _imports_6 from '@/assets/img/testing/tec_s.png'
import _imports_7 from '@/assets/img/individual_manual.png'
import _imports_8 from '@/assets/img/org_manual.png'
import _imports_9 from '@/assets/img/testing/putt_e_2_0_coaching.png'
import _imports_10 from '@/assets/img/testing/putt_m_2_0_coaching.png'
import _imports_11 from '@/assets/img/testing/putt_h_2_0_coaching.png'
import _imports_12 from '@/assets/img/testing/putt_u_2_0_coaching.png'
import _imports_13 from '@/assets/img/testing/tocc_e_coaching.png'
import _imports_14 from '@/assets/img/testing/tocc_m_coaching.png'
import _imports_15 from '@/assets/img/testing/tocc_h_coaching.png'
import _imports_16 from '@/assets/img/testing/tec_coaching.png'
import _imports_17 from '@/assets/img/talent_e.png'
import _imports_18 from '@/assets/img/talent_m.png'
import _imports_19 from '@/assets/img/talent_h.png'
import _imports_20 from '@/assets/img/talent_u.png'
import _imports_21 from '@/assets/img/startup_e.png'
import _imports_22 from '@/assets/img/startup_m.png'
import _imports_23 from '@/assets/img/startup_h.png'
import _imports_24 from '@/assets/img/career_e.png'
import _imports_25 from '@/assets/img/career_m.png'
import _imports_26 from '@/assets/img/career_h.png'
import _imports_27 from '@/assets/img/career_u.png'
import _imports_28 from '@/assets/img/growth_m.png'
import _imports_29 from '@/assets/img/growth_h.png'
import _imports_30 from '@/assets/img/growth_u.png'
import _imports_31 from '@/assets/img/expert_e.png'
import _imports_32 from '@/assets/img/expert_h.png'
import _imports_33 from '@/assets/img/expert_b.png'
import _imports_34 from '@/assets/img/expert_p.png'
import _imports_35 from '@/assets/img/pro.png'
import _imports_36 from '@/assets/thum_img/kp708b/banner/82bd168d504ed8ad7ee5e1a716a33aba_water__c1_w278_h70.jpg'
import _imports_37 from '@/assets/thum_img/kp708b/banner/87f8408df5f1dc10fa8bcf82d8ff0db2_water__c1_w278_h70.jpg'
import _imports_38 from '@/assets/thum_img/kp708b/banner/bce288d618734adf7ec12768fd2b4455_water__c1_w278_h70.png'
import _imports_39 from '@/assets/thum_img/kp708b/banner/ca7d5532cc9f31e9233e393ac61617f2_water__c1_w278_h70.png'


const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "spot_pc" }
const _hoisted_3 = { class: "mblock" }
const _hoisted_4 = { class: "mblock_style_01" }
const _hoisted_5 = { class: "width_wrap" }
const _hoisted_6 = { class: "mblock_style_02" }
const _hoisted_7 = { class: "width_wrap" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  class: "pm-login_b_login_b",
  style: {"position":"relative"}
}
const _hoisted_10 = { class: "body" }
const _hoisted_11 = {
  class: "login-type-selector",
  style: {"margin-bottom":"8px","text-align":"left","padding-left":"5px"}
}
const _hoisted_12 = { style: {"margin-right":"10px","font-size":"0.85em"} }
const _hoisted_13 = { style: {"font-size":"0.85em"} }
const _hoisted_14 = { class: "from" }
const _hoisted_15 = ["placeholder"]
const _hoisted_16 = ["required"]
const _hoisted_17 = { class: "checks" }
const _hoisted_18 = {
  key: 0,
  class: "nav"
}
const _hoisted_19 = {
  key: 1,
  class: "nav"
}
const _hoisted_20 = {
  key: 2,
  class: "social-login-buttons",
  style: {"margin-top":"8px","text-align":"center","padding-top":"8px","border-top":"1px solid #eee"}
}
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { class: "pm-login_b_login_b" }
const _hoisted_23 = { class: "body" }
const _hoisted_24 = { class: "msg" }
const _hoisted_25 = { class: "nav" }
const _hoisted_26 = { class: "box2" }
const _hoisted_27 = { class: "box2" }
const _hoisted_28 = { class: "mblock_style_03" }
const _hoisted_29 = { class: "width_wrap" }
const _hoisted_30 = { class: "bbs_wrap" }
const _hoisted_31 = { class: "pm-board_list_mnotice" }
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { key: 1 }
const _hoisted_34 = { key: 2 }
const _hoisted_35 = { class: "bbs_wrap" }
const _hoisted_36 = { class: "pm-board_list_mboard" }
const _hoisted_37 = { key: 0 }
const _hoisted_38 = { key: 1 }
const _hoisted_39 = { key: 2 }
const _hoisted_40 = { class: "bbs_wrap" }
const _hoisted_41 = { class: "pm-board_list_mfaq" }
const _hoisted_42 = { key: 0 }
const _hoisted_43 = { key: 1 }
const _hoisted_44 = { key: 2 }

import P_PUTT_Items from "@/views/product/testing/PUTT_Items.vue";
import P_TOCC_Items from "@/views/product/testing/TOCC_Items.vue";
import C_PUTT_Items from "@/views/product/coaching/PUTT_Items.vue";
import C_TOCC_Items from "@/views/product/coaching/TOCC_Items.vue";
import Talent_Items from "@/views/product/activity/Talent_Items.vue";
import Career_Items from "@/views/product/activity/Career_Items.vue";
import Growth_Items from "@/views/product/activity/Growth_Items.vue";
import Startup_Items from "@/views/product/activity/Startup_Items.vue";
import Expert_Items from "@/views/product/expert/Expert_Items.vue";
import Certification_Items from "@/views/product/expert/Certification_Items.vue";

import { NIcon } from "naive-ui";
import { ChevronForward } from "@vicons/ionicons5";
import { LocationSharp } from "@vicons/ionicons5";
import carousel from "vue-owl-carousel/src/Carousel";
import Banner from "@/components/Banner.vue";
import Loading from "@/components/Loading.vue";
import SubLoading from "@/components/SubLoading.vue";
import { USER_ROUTES } from "@/assets/route_constants";
import { useAuth } from "@/composables/useAuth";
import { firebaseAuth, getCallable, makeCallApiParam } from "@/config/env";
import { Notice } from "@/model/notice";
import { Qna } from "@/model/qna";
import { ref, onMounted, watch, computed } from "vue";
import { Press } from "@/model/press";
import * as common from "@/assets/common/common";
import * as constant from "@/constants/constant";
import { useRouter } from "vue-router";
import { useAlertDialog } from "@/composables/useAlert";
const getBoards = "getBoards";


export default /*@__PURE__*/_defineComponent({
  __name: 'Home',
  setup(__props) {

const useAlert = useAlertDialog();
const router = useRouter();

const {
  loginType,
  form,
  loading,
  isLoggedIn,
  loggedInUserId,
  isOrgUser,
  isOrgAdmin,
  signInWithGoogle,
  signInWithKakao,
  showForgotPasswordModal,
  forgotPasswordUid,
  forgotPasswordLoading,
  openForgotPasswordModal,
  closeForgotPasswordModal,
  handleForgotPasswordRequest,
  handleSubmit,
  handleLogout,
} = useAuth();

watch(loginType, (newLoginType, oldLoginType) => {
  if (newLoginType !== oldLoginType) {
    form.value.orgId = "";
    form.value.uid = "";
    form.value.password = "";
    // 필요하다면 '아이디 저장' 등의 체크박스 상태도 초기화할 수 있습니다.
  }
});

const loginButtonHeight = computed(() => {
  if (loginType.value === "organization") {
    // 기관 아이디 (35px) + margin-bottom (5px) + 사용자 아이디 (35px) + margin-top (8px) + 비밀번호 (35px)
    return "118px"; // 35 + 5 + 35 + 8 + 35 = 118px
  } else {
    // 아이디 (35px) + margin-top (8px) + 비밀번호 (35px)
    return "78px"; // 35 + 8 + 35 = 78px
  }
});

const getCallApiCallable = getCallable("callApi");
const noticeList = ref<Notice[]>([]);
const qnaList = ref<Qna[]>([]);
const pressList = ref<Press[]>([]);
const isNoticeListLoading = ref(false);
const isPressListLoading = ref(false);
const isQnaListLoading = ref(false);

async function showAlertAndNavigate() {
  await useAlert("준비 중 입니다.");
}

async function moveMyPage() {
  if (!isLoggedIn.value) {
    await useAlert("회원전용 페이지 입니다. 로그인 후 이용해주세요.");
    return;
  }
  if (isOrgUser.value || isOrgAdmin.value) {
    router.push(USER_ROUTES.Mypage.Order.Org.Path);
  } else {
    router.push(USER_ROUTES.Mypage.Order.Personal.Path);
  }
}

async function getNoticeList() {
  common.asyncFunction(async () => {
    isNoticeListLoading.value = true;
    const result: any = await getCallApiCallable(
      makeCallApiParam(getBoards, {
        type: constant.boardType.NOTICE,
      })
    );
    if (common.evalFunctionResult(result)) {
      noticeList.value = common.getItemListFromFunctionResult(result);
    } else {
      console.error("Failed to load notices:", common.getResultError(result));
    }
    isNoticeListLoading.value = false;
  });
}

async function getQnaList() {
  common.asyncFunction(async () => {
    isQnaListLoading.value = true;
    const result: any = await getCallApiCallable(
      makeCallApiParam(getBoards, { type: constant.boardType.QNA })
    );
    if (common.evalFunctionResult(result)) {
      qnaList.value = common.getItemListFromFunctionResult(result);
    } else {
      console.error("Failed to load qnaList:", common.getResultError(result));
    }
    isQnaListLoading.value = false;
  });
}

async function getPressList() {
  common.asyncFunction(async () => {
    isPressListLoading.value = true;
    const result: any = await getCallApiCallable(
      makeCallApiParam(getBoards, {
        type: constant.boardType.PRESS,
      })
    );
    if (common.evalFunctionResult(result)) {
      pressList.value = common.getItemListFromFunctionResult(result);
    } else {
      console.error("Failed to load qnaList:", common.getResultError(result));
    }
    isPressListLoading.value = false;
  });
}

onMounted(() => {
  getNoticeList(); // 컴포넌트 마운트 시 공지사항 목록 가져오기
  getQnaList(); // 컴포넌트 마운트 시 FAQ 목록 가져오기
  getPressList(); // 컴포넌트 마운트 시 홍보/자료실 목록 가져오기
});

function goToExpertE() {
  router.push(USER_ROUTES.Product.Expert.Expert.Expert_e.Path);
}
function goToExpertH() {
  router.push(USER_ROUTES.Product.Expert.Expert.Expert_h.Path);
}
function goToExpertB() {
  router.push(USER_ROUTES.Product.Expert.Expert.Expert_b.Path);
}
function goToExpertP() {
  router.push(USER_ROUTES.Product.Expert.Expert.Expert_p.Path);
}

function goToGrowthM() {
  router.push(USER_ROUTES.Product.Activity.Growth.Growth_e.Path);
}
function goToGrowthH() {
  router.push(USER_ROUTES.Product.Activity.Growth.Growth_m.Path);
}
function goToGrowthU() {
  router.push(USER_ROUTES.Product.Activity.Growth.Growth_h.Path);
}

function goToCareerE() {
  router.push(USER_ROUTES.Product.Activity.Career.Career_e.Path);
}
function goToCareerM() {
  router.push(USER_ROUTES.Product.Activity.Career.Career_m.Path);
}
function goToCareerH() {
  router.push(USER_ROUTES.Product.Activity.Career.Career_h.Path);
}
function goToCareerU() {
  router.push(USER_ROUTES.Product.Activity.Career.Career_u.Path);
}

function goToStartUpCE() {
  router.push(USER_ROUTES.Product.Activity.Startup.Startup_e.Path);
}
function goToStartUpCM() {
  router.push(USER_ROUTES.Product.Activity.Startup.Startup_m.Path);
}
function goToStartUpCH() {
  router.push(USER_ROUTES.Product.Activity.Startup.Startup_h.Path);
}

function goToTalentCE() {
  router.push(USER_ROUTES.Product.Activity.Talent.Talent_e.Path);
}
function goToTalentCM() {
  router.push(USER_ROUTES.Product.Activity.Talent.Talent_m.Path);
}
function goToTalentCH() {
  router.push(USER_ROUTES.Product.Activity.Talent.Talent_h.Path);
}
function goToTalentCU() {
  router.push(USER_ROUTES.Product.Activity.Talent.Talent_u.Path);
}

function goToToccCE() {
  router.push(USER_ROUTES.Product.Coaching.Tocc.Tocc_e.Path);
}
function goToToccCM() {
  router.push(USER_ROUTES.Product.Coaching.Tocc.Tocc_m.Path);
}
function goToToccCH() {
  router.push(USER_ROUTES.Product.Coaching.Tocc.Tocc_h.Path);
}
function goToToccCU() {
  router.push(USER_ROUTES.Product.Coaching.Tocc.Tec.Path);
}

function goToPuttCE() {
  router.push(USER_ROUTES.Product.Coaching.Putt.Putt_e.Path);
}
function goToPuttCM() {
  router.push(USER_ROUTES.Product.Coaching.Putt.Putt_m.Path);
}
function goToPuttCH() {
  router.push(USER_ROUTES.Product.Coaching.Putt.Putt_h.Path);
}
function goToPuttCU() {
  router.push(USER_ROUTES.Product.Coaching.Putt.Putt_u.Path);
}

function goToToccC() {
  router.push(USER_ROUTES.Product.Testing.Tocc.Tocc_e.Path);
}
function goToToccY() {
  router.push(USER_ROUTES.Product.Testing.Tocc.Tocc_h.Path);
}
function goToTecP() {
  router.push(USER_ROUTES.Product.Testing.Tocc.Tec.Path);
}

function goToPuttE() {
  router.push(USER_ROUTES.Product.Testing.Putt.Putt_e.Path);
}
function goToPuttM() {
  router.push(USER_ROUTES.Product.Testing.Putt.Putt_m.Path);
}
function goToPuttH() {
  router.push(USER_ROUTES.Product.Testing.Putt.Putt_h.Path);
}
function goToPuttU() {
  router.push(USER_ROUTES.Product.Testing.Putt.Putt_u.Path);
}

function goToIndividualInstruction() {
  router.push(USER_ROUTES.Instruction.individual.Path);
}

function goToOrgInstruction() {
  router.push(USER_ROUTES.Instruction.org.Path);
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_input = _resolveComponent("n-input")!
  const _component_n_form_item = _resolveComponent("n-form-item")!
  const _component_n_space = _resolveComponent("n-space")!
  const _component_n_form = _resolveComponent("n-form")!
  const _component_n_modal = _resolveComponent("n-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(carousel), {
        dots: false,
        autoplay: true,
        nav: false,
        items: 1,
        class: "spot_03"
      }, {
        default: _withCtx(() => _cache[12] || (_cache[12] = [
          _createElementVNode("div", {
            class: "item",
            id: "item"
          }, [
            _createElementVNode("a", { class: "ori" }, [
              _createElementVNode("div", { class: "item_caption" }, [
                _createElementVNode("h1", null, [
                  _createTextVNode(" CreateX는 새로운 시대 새로운 꿈 새로운 교육을 대표하는 브랜드로,"),
                  _createElementVNode("br"),
                  _createTextVNode(" 성장기 학생들이 최고가 되는 경험을 통해 꿈을 실현하도록 지원합니다. ")
                ])
              ])
            ])
          ], -1)
        ])),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("ul", null, [
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                to: `${_unref(USER_ROUTES).Product.Testing.Putt.Path}`
              }, {
                default: _withCtx(() => [
                  _cache[13] || (_cache[13] = _createElementVNode("span", null, "경험을 진단하다!", -1)),
                  _cache[14] || (_cache[14] = _createElementVNode("h1", null, "진단검사", -1)),
                  _createVNode(_unref(NIcon), { size: "30" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ChevronForward))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["to"])
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                to: `${_unref(USER_ROUTES).Product.Coaching.Putt.Path}`
              }, {
                default: _withCtx(() => [
                  _cache[15] || (_cache[15] = _createElementVNode("span", null, "나를 디자인하다!", -1)),
                  _cache[16] || (_cache[16] = _createElementVNode("h1", null, "학습진로 상담코칭", -1)),
                  _createVNode(_unref(NIcon), { size: "30" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ChevronForward))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["to"])
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                to: `${_unref(USER_ROUTES).Product.Activity.Talent.Path}`
              }, {
                default: _withCtx(() => [
                  _cache[17] || (_cache[17] = _createElementVNode("span", null, "최고의 나를 경험하다!", -1)),
                  _cache[18] || (_cache[18] = _createElementVNode("h1", null, "Activity", -1)),
                  _createVNode(_unref(NIcon), { size: "30" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ChevronForward))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["to"])
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                to: `${_unref(USER_ROUTES).Product.Expert.Expert.Path}`
              }, {
                default: _withCtx(() => [
                  _cache[19] || (_cache[19] = _createElementVNode("span", null, "미래를 디자인하다!", -1)),
                  _cache[20] || (_cache[20] = _createElementVNode("h1", null, "전문가 교육", -1)),
                  _createVNode(_unref(NIcon), { size: "30" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ChevronForward))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["to"])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("ul", null, [
          (!_unref(isLoggedIn))
            ? (_openBlock(), _createElementBlock("li", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("form", {
                    name: "left_login_box",
                    onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_unref(handleSubmit) && _unref(handleSubmit)(...args)), ["prevent"]))
                  }, [
                    _cache[27] || (_cache[27] = _createElementVNode("input", {
                      type: "hidden",
                      name: "re_url",
                      value: ""
                    }, null, -1)),
                    _createElementVNode("fieldset", _hoisted_10, [
                      _cache[26] || (_cache[26] = _createElementVNode("legend", null, "로그인 폼", -1)),
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("label", _hoisted_12, [
                          _withDirectives(_createElementVNode("input", {
                            type: "radio",
                            name: "home_login_type_radio",
                            value: "user",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(loginType) ? (loginType).value = $event : null)),
                            style: {"vertical-align":"middle","margin-right":"3px"}
                          }, null, 512), [
                            [_vModelRadio, _unref(loginType)]
                          ]),
                          _cache[21] || (_cache[21] = _createTextVNode(" 개인 "))
                        ]),
                        _createElementVNode("label", _hoisted_13, [
                          _withDirectives(_createElementVNode("input", {
                            type: "radio",
                            name: "home_login_type_radio",
                            value: "organization",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(loginType) ? (loginType).value = $event : null)),
                            style: {"vertical-align":"middle","margin-right":"3px"}
                          }, null, 512), [
                            [_vModelRadio, _unref(loginType)]
                          ]),
                          _cache[22] || (_cache[22] = _createTextVNode(" 기관 "))
                        ])
                      ]),
                      _createElementVNode("dl", _hoisted_14, [
                        _createElementVNode("dt", null, [
                          (_unref(loginType) === 'organization')
                            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                key: 0,
                                type: "text",
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(form).orgId) = $event)),
                                placeholder: "기관 아이디",
                                style: {"margin-bottom":"5px"}
                              }, null, 512)), [
                                [_vModelText, _unref(form).orgId]
                              ])
                            : _createCommentVNode("", true),
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(form).uid) = $event)),
                            placeholder: 
                          _unref(loginType) === 'organization'
                            ? '사용자 아이디'
                            : '아이디'
                        
                          }, null, 8, _hoisted_15), [
                            [_vModelText, _unref(form).uid]
                          ]),
                          _withDirectives(_createElementVNode("input", {
                            type: "password",
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(form).password) = $event)),
                            placeholder: "비밀번호",
                            required: _unref(loginType) === 'user'
                          }, null, 8, _hoisted_16), [
                            [_vModelText, _unref(form).password]
                          ])
                        ]),
                        _createElementVNode("dd", null, [
                          _createVNode(_component_n_button, {
                            type: "submit",
                            loading: _unref(loading),
                            "attr-type": "submit",
                            style: _normalizeStyle({
                          width: '100%',
                          height: loginButtonHeight.value,
                          backgroundColor: '#c0c0c0',
                          color: 'white',
                          border: 'none',
                          fontWeight: 600,
                          fontSize: '14px',
                        })
                          }, {
                            default: _withCtx(() => _cache[23] || (_cache[23] = [
                              _createTextVNode(" 로그인 ")
                            ])),
                            _: 1
                          }, 8, ["loading", "style"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("label", null, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            name: "id_save",
                            value: "1",
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(form).idSave) = $event))
                          }, null, 512), [
                            [_vModelCheckbox, _unref(form).idSave]
                          ]),
                          _cache[24] || (_cache[24] = _createTextVNode("  ")),
                          _cache[25] || (_cache[25] = _createElementVNode("span", null, "아이디 저장", -1))
                        ])
                      ])
                    ])
                  ], 32),
                  (_unref(loginType) === 'organization')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                        _createVNode(_component_router_link, {
                          to: `${_unref(USER_ROUTES).RequestOrgRegist.Path}`,
                          style: {"width":"100%","margin-right":"0","font-size":"15px"}
                        }, {
                          default: _withCtx(() => _cache[28] || (_cache[28] = [
                            _createTextVNode(" [신규]기관등록신청 ")
                          ])),
                          _: 1
                        }, 8, ["to"])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                        _createVNode(_component_router_link, {
                          to: `${_unref(USER_ROUTES).Join.Path}`
                        }, {
                          default: _withCtx(() => _cache[29] || (_cache[29] = [
                            _createTextVNode("회원가입")
                          ])),
                          _: 1
                        }, 8, ["to"]),
                        _createElementVNode("a", {
                          href: "#",
                          onClick: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_unref(openForgotPasswordModal) && _unref(openForgotPasswordModal)(...args)), ["prevent"]))
                        }, "비밀번호찾기")
                      ])),
                  (_unref(loginType) === 'user')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                        _createVNode(_component_n_button, {
                          type: "button",
                          onClick: _unref(signInWithGoogle),
                          style: {"background-color":"#db4437","color":"white","border":"none","border-radius":"4px","cursor":"pointer","margin-right":"10px","font-size":"0.85em","padding":"8px 12px"}
                        }, {
                          default: _withCtx(() => _cache[30] || (_cache[30] = [
                            _createTextVNode(" 구글 로그인 ")
                          ])),
                          _: 1
                        }, 8, ["onClick"]),
                        _createVNode(_component_n_button, {
                          type: "button",
                          onClick: _unref(signInWithKakao),
                          style: {"background-color":"#fee500","color":"#3c1e1e","border":"none","border-radius":"4px","cursor":"pointer","font-size":"0.85em","padding":"8px 12px"}
                        }, {
                          default: _withCtx(() => _cache[31] || (_cache[31] = [
                            _createTextVNode(" 카카오 로그인 ")
                          ])),
                          _: 1
                        }, 8, ["onClick"])
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(loading))
                    ? (_openBlock(), _createBlock(SubLoading, { key: 3 }))
                    : _createCommentVNode("", true)
                ])
              ]))
            : (_openBlock(), _createElementBlock("li", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("p", _hoisted_24, [
                      _createElementVNode("strong", null, _toDisplayString(_unref(loggedInUserId)), 1),
                      _cache[32] || (_cache[32] = _createTextVNode("님 반갑습니다. "))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    (_unref(isOrgUser) || _unref(isOrgAdmin))
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          to: `${_unref(USER_ROUTES).Mypage.Order.Org.Path}`
                        }, {
                          default: _withCtx(() => _cache[33] || (_cache[33] = [
                            _createTextVNode("마이페이지")
                          ])),
                          _: 1
                        }, 8, ["to"]))
                      : (_openBlock(), _createBlock(_component_router_link, {
                          key: 1,
                          to: `${_unref(USER_ROUTES).Mypage.Order.Personal.Path}`
                        }, {
                          default: _withCtx(() => _cache[34] || (_cache[34] = [
                            _createTextVNode("마이페이지")
                          ])),
                          _: 1
                        }, 8, ["to"])),
                    _createElementVNode("a", {
                      href: "#",
                      onClick: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_unref(handleLogout) && _unref(handleLogout)(...args)), ["prevent"]))
                    }, "로그아웃")
                  ])
                ])
              ])),
          _createElementVNode("li", _hoisted_26, [
            _createVNode(_component_router_link, {
              to: `${_unref(USER_ROUTES).Price.Personal.Path}`,
              class: "btn4"
            }, {
              default: _withCtx(() => [
                _cache[35] || (_cache[35] = _createElementVNode("dl", null, [
                  _createElementVNode("dt", null, "개인"),
                  _createElementVNode("dd", null, "예약 및 신청하기")
                ], -1)),
                _createVNode(_unref(NIcon), {
                  size: "25",
                  class: "arrow-icon"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ChevronForward))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["to"]),
            _createVNode(_component_router_link, {
              to: `${_unref(USER_ROUTES).Instruction.individual.Path}`,
              class: "btn2"
            }, {
              default: _withCtx(() => [
                _cache[36] || (_cache[36] = _createElementVNode("dl", null, [
                  _createElementVNode("dt", null, "이용 안내"),
                  _createElementVNode("dd")
                ], -1)),
                _createVNode(_unref(NIcon), {
                  color: "#BE7A42",
                  size: "25",
                  class: "arrow-icon"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ChevronForward))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["to"]),
            _createVNode(_component_router_link, {
              to: `${_unref(USER_ROUTES).Inquiry.Path}`,
              class: "btn2"
            }, {
              default: _withCtx(() => [
                _cache[37] || (_cache[37] = _createElementVNode("dl", null, [
                  _createElementVNode("dt", null, "문의 하기"),
                  _createElementVNode("dd")
                ], -1)),
                _createVNode(_unref(NIcon), {
                  color: "#BE7A42",
                  size: "25",
                  class: "arrow-icon"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ChevronForward))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _createElementVNode("li", _hoisted_27, [
            _createVNode(_component_router_link, {
              to: `${_unref(USER_ROUTES).Price.Org.Path}`,
              class: "btn1"
            }, {
              default: _withCtx(() => [
                _cache[38] || (_cache[38] = _createElementVNode("dl", null, [
                  _createElementVNode("dt", null, "기관"),
                  _createElementVNode("dd", null, "예약 및 신청하기")
                ], -1)),
                _createVNode(_unref(NIcon), {
                  size: "25",
                  class: "arrow-icon"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ChevronForward))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["to"]),
            _createVNode(_component_router_link, {
              to: {},
              onClick: moveMyPage,
              class: "btn5"
            }, {
              default: _withCtx(() => [
                _cache[39] || (_cache[39] = _createElementVNode("dl", null, [
                  _createElementVNode("dt", null, "개인·기관"),
                  _createElementVNode("dd", null, "검사 실시하기")
                ], -1)),
                _createVNode(_unref(NIcon), {
                  size: "25",
                  class: "arrow-icon"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ChevronForward))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: {},
              onClick: moveMyPage,
              class: "btn3"
            }, {
              default: _withCtx(() => [
                _cache[40] || (_cache[40] = _createElementVNode("dl", null, [
                  _createElementVNode("dt", null, "개인·기관"),
                  _createElementVNode("dd", null, "결과리포트 열람하기")
                ], -1)),
                _createVNode(_unref(NIcon), {
                  size: "25",
                  class: "arrow-icon"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ChevronForward))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _createVNode(_component_n_modal, {
      show: _unref(showForgotPasswordModal),
      "onUpdate:show": _cache[10] || (_cache[10] = ($event: any) => (_isRef(showForgotPasswordModal) ? (showForgotPasswordModal).value = $event : null)),
      preset: "card",
      style: {"width":"500px"},
      title: "비밀번호 찾기/재설정",
      "mask-closable": false,
      closable: true,
      onAfterLeave: _cache[11] || (_cache[11] = ($event: any) => (forgotPasswordUid.value = ''))
    }, {
      default: _withCtx(() => [
        _cache[43] || (_cache[43] = _createElementVNode("p", { style: {"margin-bottom":"15px"} }, " 아이디를 입력해주세요. 가입 시 등록된 이메일 주소로 임시 비밀번호가 전송됩니다. 로그인 후 반드시 비밀번호를 변경해주세요. ", -1)),
        _createVNode(_component_n_form, {
          onSubmit: _withModifiers(_unref(handleForgotPasswordRequest), ["prevent"])
        }, {
          default: _withCtx(() => [
            _createVNode(_component_n_form_item, {
              label: "아이디",
              path: "forgotPasswordUid"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_n_input, {
                  value: _unref(forgotPasswordUid),
                  "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => (_isRef(forgotPasswordUid) ? (forgotPasswordUid).value = $event : null)),
                  placeholder: "아이디 입력",
                  onKeydown: _withKeys(_withModifiers(_unref(handleForgotPasswordRequest), ["prevent"]), ["enter"])
                }, null, 8, ["value", "onKeydown"])
              ]),
              _: 1
            }),
            _createVNode(_component_n_space, { justify: "end" }, {
              default: _withCtx(() => [
                _createVNode(_component_n_button, {
                  onClick: _unref(closeForgotPasswordModal),
                  disabled: _unref(forgotPasswordLoading)
                }, {
                  default: _withCtx(() => _cache[41] || (_cache[41] = [
                    _createTextVNode("취소")
                  ])),
                  _: 1
                }, 8, ["onClick", "disabled"]),
                _createVNode(_component_n_button, {
                  type: "primary",
                  "attr-type": "submit",
                  loading: _unref(forgotPasswordLoading)
                }, {
                  default: _withCtx(() => _cache[42] || (_cache[42] = [
                    _createTextVNode(" 임시 비밀번호 발송 ")
                  ])),
                  _: 1
                }, 8, ["loading"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["onSubmit"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createElementVNode("div", _hoisted_28, [
      _createElementVNode("div", _hoisted_29, [
        _createElementVNode("ul", null, [
          _createElementVNode("li", null, [
            _createElementVNode("h1", null, [
              _cache[45] || (_cache[45] = _createTextVNode(" 공지사항 ")),
              _createVNode(_component_router_link, {
                to: `${_unref(USER_ROUTES).Notice.Path}`
              }, {
                default: _withCtx(() => _cache[44] || (_cache[44] = [
                  _createTextVNode("더보기 +")
                ])),
                _: 1
              }, 8, ["to"])
            ]),
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                (isNoticeListLoading.value)
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_32, _cache[46] || (_cache[46] = [
                      _createElementVNode("li", null, [
                        _createElementVNode("p", {
                          class: "empty",
                          style: {"text-align":"center","padding":"10px 0"}
                        }, " 공지사항 조회 중... ")
                      ], -1)
                    ])))
                  : (noticeList.value.length > 0)
                    ? (_openBlock(), _createElementBlock("ul", _hoisted_33, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(noticeList.value.slice(0, 4), (notice) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: notice.SK
                          }, [
                            _createVNode(_component_router_link, {
                              to: {
                        name: _unref(USER_ROUTES).Notice.Content.Name,
                        params: { id: notice.SK },
                      }
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("dl", null, [
                                  _createElementVNode("dt", null, _toDisplayString(notice.title), 1),
                                  _createElementVNode("dd", null, _toDisplayString(common.getYYYYMMDD2(notice.createdDate)), 1)
                                ])
                              ]),
                              _: 2
                            }, 1032, ["to"])
                          ]))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("ul", _hoisted_34, _cache[47] || (_cache[47] = [
                        _createElementVNode("li", null, [
                          _createElementVNode("p", {
                            class: "empty",
                            style: {"text-align":"center","padding":"10px 0"}
                          }, " 공지사항이 없습니다. ")
                        ], -1)
                      ])))
              ])
            ])
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("h1", null, [
              _cache[49] || (_cache[49] = _createTextVNode(" 홍보/자료실 ")),
              _createVNode(_component_router_link, {
                to: `${_unref(USER_ROUTES).Press.Path}`
              }, {
                default: _withCtx(() => _cache[48] || (_cache[48] = [
                  _createTextVNode("더보기 +")
                ])),
                _: 1
              }, 8, ["to"])
            ]),
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("div", _hoisted_36, [
                (isPressListLoading.value)
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_37, _cache[50] || (_cache[50] = [
                      _createElementVNode("li", null, [
                        _createElementVNode("p", {
                          class: "empty",
                          style: {"text-align":"center","padding":"10px 0"}
                        }, " 홍보자료 조회 중... ")
                      ], -1)
                    ])))
                  : (pressList.value.length > 0)
                    ? (_openBlock(), _createElementBlock("ul", _hoisted_38, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pressList.value.slice(0, 4), (press) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: press.SK
                          }, [
                            _createVNode(_component_router_link, {
                              to: {
                        name: _unref(USER_ROUTES).Press.Content.Name,
                        params: { id: press.SK },
                      }
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("dl", null, [
                                  _createElementVNode("dt", null, _toDisplayString(press.title), 1),
                                  _createElementVNode("dd", null, _toDisplayString(common.getYYYYMMDD2(press.createdDate)), 1)
                                ])
                              ]),
                              _: 2
                            }, 1032, ["to"])
                          ]))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("ul", _hoisted_39, _cache[51] || (_cache[51] = [
                        _createElementVNode("li", null, [
                          _createElementVNode("p", {
                            class: "empty",
                            style: {"text-align":"center","padding":"10px 0"}
                          }, " 홍보자료가 없습니다. ")
                        ], -1)
                      ])))
              ])
            ])
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("h1", null, [
              _cache[53] || (_cache[53] = _createTextVNode(" FAQ ")),
              _createVNode(_component_router_link, {
                to: `${_unref(USER_ROUTES).Qna.Path}`
              }, {
                default: _withCtx(() => _cache[52] || (_cache[52] = [
                  _createTextVNode("더보기 +")
                ])),
                _: 1
              }, 8, ["to"])
            ]),
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("div", _hoisted_41, [
                (isQnaListLoading.value)
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_42, _cache[54] || (_cache[54] = [
                      _createElementVNode("li", null, [
                        _createElementVNode("p", {
                          class: "empty",
                          style: {"text-align":"center","padding":"10px 0"}
                        }, " FAQ 조회 중... ")
                      ], -1)
                    ])))
                  : (qnaList.value.length > 0)
                    ? (_openBlock(), _createElementBlock("ul", _hoisted_43, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(qnaList.value.slice(0, 4), (qna) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: qna.SK
                          }, [
                            _createVNode(_component_router_link, {
                              to: {
                        name: _unref(USER_ROUTES).Qna.Content.Name,
                        params: { id: qna.SK },
                      }
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("dl", null, [
                                  _createElementVNode("dt", null, _toDisplayString(qna.question), 1),
                                  _createElementVNode("dd", null, _toDisplayString(common.getYYYYMMDD2(qna.createdDate)), 1)
                                ])
                              ]),
                              _: 2
                            }, 1032, ["to"])
                          ]))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("ul", _hoisted_44, _cache[55] || (_cache[55] = [
                        _createElementVNode("li", null, [
                          _createElementVNode("p", {
                            class: "empty",
                            style: {"text-align":"center","padding":"10px 0"}
                          }, " FAQ가 없습니다. ")
                        ], -1)
                      ])))
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", { class: "mblock_05" }, [
      _createElementVNode("div", {
        class: "mblock_06",
        style: {"padding":"50px 10px"}
      }, [
        _cache[61] || (_cache[61] = _createElementVNode("h1", null, "PUTT2.0 다중재능검사", -1)),
        _createElementVNode("div", {
          class: "wrap_flex",
          style: {"padding-top":"15px"}
        }, [
          _createElementVNode("div", { style: {"width":"100%","max-width":"1300px"} }, [
            _cache[60] || (_cache[60] = _createElementVNode("div", {
              class: "card-header",
              style: {"text-align":"center","margin-bottom":"15px","font-size":"16px"}
            }, [
              _createElementVNode("span", null, [
                _createTextVNode("PUTT2.0 다중재능검사는 개인의 타고난 재능과 경험을 측정하는 검사로,"),
                _createElementVNode("br"),
                _createTextVNode(" 개인이 자아 발견을 통해 꿈을 찾고 미래를 예측, 설계하여 자아 실현하도록 하는 데 목적이 있습니다."),
                _createElementVNode("br"),
                _createTextVNode(" PUTT2.0 다중재능검사는 재능의 발달단계에 따라 초등학생용, 중학생용, 고등학생용, 대학생용으로 구분, 실시합니다")
              ])
            ], -1)),
            _createElementVNode("div", { class: "wrap_flex" }, [
              _createElementVNode("div", {
                class: "card",
                onClick: goToPuttE,
                style: {"max-width":"300px"}
              }, _cache[56] || (_cache[56] = [
                _createElementVNode("div", { class: "card-body" }, [
                  _createElementVNode("img", { src: _imports_0 })
                ], -1)
              ])),
              _createElementVNode("div", {
                class: "card",
                onClick: goToPuttM,
                style: {"max-width":"300px"}
              }, _cache[57] || (_cache[57] = [
                _createElementVNode("div", { class: "card-body" }, [
                  _createElementVNode("img", { src: _imports_1 })
                ], -1)
              ])),
              _createElementVNode("div", {
                class: "card",
                onClick: goToPuttH,
                style: {"max-width":"300px"}
              }, _cache[58] || (_cache[58] = [
                _createElementVNode("div", { class: "card-body" }, [
                  _createElementVNode("img", { src: _imports_2 })
                ], -1)
              ])),
              _createElementVNode("div", {
                class: "card",
                onClick: goToPuttU,
                style: {"max-width":"300px"}
              }, _cache[59] || (_cache[59] = [
                _createElementVNode("div", { class: "card-body" }, [
                  _createElementVNode("img", { src: _imports_3 })
                ], -1)
              ]))
            ])
          ])
        ])
      ]),
      _createElementVNode("div", {
        class: "mblock_06",
        style: {"padding":"50px 10px"}
      }, [
        _cache[66] || (_cache[66] = _createElementVNode("h1", null, "TOCC·TEC 창의역량검사", -1)),
        _createElementVNode("div", {
          class: "wrap_flex",
          style: {"padding-top":"15px"}
        }, [
          _createElementVNode("div", { style: {"width":"100%","max-width":"1300px"} }, [
            _cache[65] || (_cache[65] = _createElementVNode("div", {
              class: "card-header",
              style: {"text-align":"center","margin-bottom":"15px","font-size":"16px"}
            }, [
              _createElementVNode("span", null, [
                _createTextVNode("TOCC(TEC)창의역량검사는 ‘모든 사람의 창의역량’을 총체적, 다원적으로 측정하는 검사로,"),
                _createElementVNode("br"),
                _createTextVNode(" 개인의 특별한 경험을 발굴, 확장, 극대화함으로써 행복한 현재 삶은 물론 미래 기회를 창조하도록 지원하는 데 목적이 있습니다."),
                _createElementVNode("br"),
                _createTextVNode(" TOCC창의역량검사는 창의역량의 발달단계에 따라 아동용, 청소년용으로, TEC_전문가용으로 구분, 실시합니다.")
              ])
            ], -1)),
            _createElementVNode("div", { class: "wrap_flex" }, [
              _createElementVNode("div", {
                class: "card",
                onClick: goToToccC,
                style: {"max-width":"300px"}
              }, _cache[62] || (_cache[62] = [
                _createElementVNode("div", { class: "card-body" }, [
                  _createElementVNode("img", { src: _imports_4 })
                ], -1)
              ])),
              _createElementVNode("div", {
                class: "card",
                onClick: goToToccY,
                style: {"max-width":"300px"}
              }, _cache[63] || (_cache[63] = [
                _createElementVNode("div", { class: "card-body" }, [
                  _createElementVNode("img", { src: _imports_5 })
                ], -1)
              ])),
              _createElementVNode("div", {
                class: "card",
                onClick: goToTecP,
                style: {"max-width":"300px"}
              }, _cache[64] || (_cache[64] = [
                _createElementVNode("div", { class: "card-body" }, [
                  _createElementVNode("img", { src: _imports_6 })
                ], -1)
              ]))
            ])
          ])
        ])
      ]),
      _createElementVNode("div", { class: "mblock_06" }, [
        _cache[71] || (_cache[71] = _createElementVNode("h1", null, [
          _createTextVNode("PUTT2.0 · TOCC · TEC"),
          _createElementVNode("br"),
          _createTextVNode("검사 및 상담코칭 이용 안내")
        ], -1)),
        _createElementVNode("div", {
          class: "wrap_flex",
          style: {"padding-top":"15px"}
        }, [
          _createElementVNode("div", { style: {"width":"100%","max-width":"450px"} }, [
            _cache[68] || (_cache[68] = _createElementVNode("div", {
              class: "card-header",
              style: {"text-align":"center","margin-bottom":"15px"}
            }, [
              _createElementVNode("h2", null, "개인"),
              _createElementVNode("p", null, " ※ 전문 학습진로 상담코칭 지원 대상, 피검자 1인 또는 소수 개인 ")
            ], -1)),
            _createElementVNode("div", {
              class: "card card-borad",
              onClick: goToIndividualInstruction
            }, _cache[67] || (_cache[67] = [
              _createElementVNode("div", {
                class: "card-body",
                style: {"height":"130px"}
              }, [
                _createElementVNode("h3", null, "온라인 검사 실시 안내"),
                _createElementVNode("img", {
                  src: _imports_7,
                  alt: "개인 아이콘",
                  class: "icon2"
                }),
                _createElementVNode("p", null, [
                  _createTextVNode(" 검사 실시 준비 >> 검사 실시 >> 결과 확인·"),
                  _createElementVNode("span", { class: "highlight" }, "상담코칭")
                ])
              ], -1)
            ]))
          ]),
          _createElementVNode("div", { style: {"width":"100%","max-width":"450px"} }, [
            _cache[70] || (_cache[70] = _createElementVNode("div", {
              class: "card-header",
              style: {"text-align":"center","margin-bottom":"15px"}
            }, [
              _createElementVNode("h2", null, "기관"),
              _createElementVNode("p", null, " ※ 전문 학습진로상담코칭 자체 지원 가능 기관, 피검사자 16인 이상의 단체, 기관 ")
            ], -1)),
            _createElementVNode("div", {
              class: "card card-borad",
              onClick: goToOrgInstruction
            }, _cache[69] || (_cache[69] = [
              _createStaticVNode("<div class=\"card-body\" style=\"height:130px;\" data-v-ec70352a><h3 style=\"margin-bottom:20px;\" data-v-ec70352a>온라인 검사 실시 안내</h3><img style=\"height:43px !important;width:45px !important;\" src=\"" + _imports_8 + "\" alt=\"기관 아이콘\" class=\"icon2\" data-v-ec70352a><p style=\"margin-top:3px;\" data-v-ec70352a> 검사 실시 준비 &gt;&gt; 검사 실시 &gt;&gt; 결과 확인·<span class=\"highlight\" data-v-ec70352a>상담코칭</span></p></div>", 1)
            ]))
          ])
        ])
      ]),
      _createElementVNode("div", {
        class: "mblock_06",
        style: {"padding":"50px 10px"}
      }, [
        _cache[81] || (_cache[81] = _createElementVNode("h1", null, "학습진로 상담코칭", -1)),
        _createElementVNode("div", {
          class: "wrap_flex",
          style: {"padding-top":"15px"}
        }, [
          _createElementVNode("div", { style: {"width":"100%","max-width":"1300px"} }, [
            _cache[80] || (_cache[80] = _createElementVNode("div", {
              class: "card-header",
              style: {"text-align":"center","margin-bottom":"15px","font-size":"16px"}
            }, [
              _createElementVNode("span", null, [
                _createTextVNode("PUTT2.0 및 TOCC(TEC) 결과를 바탕으로,"),
                _createElementVNode("br"),
                _createTextVNode(" 학생의 학업 문제를 정의, 해결하고 신체적 및 지적 성장 발달과 세상의 변화에 대처하기 위한 전략을 제시하는 데 목적이 있습니다."),
                _createElementVNode("br"),
                _createTextVNode(" PUTT은 개인 재능의 최적화를, TOCC*TEC은 개인 재능의 극대화를 목표로 합니다.")
              ])
            ], -1)),
            _createElementVNode("div", { class: "wrap_flex" }, [
              _createElementVNode("div", {
                class: "card",
                onClick: goToPuttCE,
                style: {"max-width":"300px"}
              }, _cache[72] || (_cache[72] = [
                _createElementVNode("div", { class: "card-body" }, [
                  _createElementVNode("img", { src: _imports_9 })
                ], -1)
              ])),
              _createElementVNode("div", {
                class: "card",
                onClick: goToPuttCM,
                style: {"max-width":"300px"}
              }, _cache[73] || (_cache[73] = [
                _createElementVNode("div", { class: "card-body" }, [
                  _createElementVNode("img", { src: _imports_10 })
                ], -1)
              ])),
              _createElementVNode("div", {
                class: "card",
                onClick: goToPuttCH,
                style: {"max-width":"300px"}
              }, _cache[74] || (_cache[74] = [
                _createElementVNode("div", { class: "card-body" }, [
                  _createElementVNode("img", { src: _imports_11 })
                ], -1)
              ])),
              _createElementVNode("div", {
                class: "card",
                onClick: goToPuttCU,
                style: {"max-width":"300px"}
              }, _cache[75] || (_cache[75] = [
                _createElementVNode("div", { class: "card-body" }, [
                  _createElementVNode("img", { src: _imports_12 })
                ], -1)
              ]))
            ]),
            _createElementVNode("div", {
              class: "wrap_flex",
              style: {"padding-top":"20px"}
            }, [
              _createElementVNode("div", {
                class: "card",
                onClick: goToToccCE,
                style: {"max-width":"300px"}
              }, _cache[76] || (_cache[76] = [
                _createElementVNode("div", { class: "card-body" }, [
                  _createElementVNode("img", { src: _imports_13 })
                ], -1)
              ])),
              _createElementVNode("div", {
                class: "card",
                onClick: goToToccCM,
                style: {"max-width":"300px"}
              }, _cache[77] || (_cache[77] = [
                _createElementVNode("div", { class: "card-body" }, [
                  _createElementVNode("img", { src: _imports_14 })
                ], -1)
              ])),
              _createElementVNode("div", {
                class: "card",
                onClick: goToToccCH,
                style: {"max-width":"300px"}
              }, _cache[78] || (_cache[78] = [
                _createElementVNode("div", { class: "card-body" }, [
                  _createElementVNode("img", { src: _imports_15 })
                ], -1)
              ])),
              _createElementVNode("div", {
                class: "card",
                onClick: goToToccCU,
                style: {"max-width":"300px"}
              }, _cache[79] || (_cache[79] = [
                _createElementVNode("div", { class: "card-body" }, [
                  _createElementVNode("img", { src: _imports_16 })
                ], -1)
              ]))
            ])
          ])
        ])
      ]),
      _createElementVNode("div", {
        class: "mblock_06",
        style: {"padding":"50px 10px"}
      }, [
        _cache[87] || (_cache[87] = _createElementVNode("h1", null, "재능탐색 · 진로탐색 · 전공탐색 · 직업탐색 프로젝트", -1)),
        _createElementVNode("div", {
          class: "wrap_flex",
          style: {"padding-top":"15px"}
        }, [
          _createElementVNode("div", { style: {"width":"100%","max-width":"1300px"} }, [
            _cache[86] || (_cache[86] = _createElementVNode("div", {
              class: "card-header",
              style: {"text-align":"center","margin-bottom":"15px","font-size":"16px"}
            }, [
              _createElementVNode("span", null, [
                _createTextVNode("PUTT2.0 기반 재능진로전공직업 탐색 프로젝트는 성장기 학생들의 발달 특성을 고려하여 "),
                _createElementVNode("br"),
                _createTextVNode("내적 성장으로 인한 현재의 변화무쌍한 관심, 재능, 과업에 직면하도록 하여 도전, 성취를 경험하도록 하는 과정입니다.")
              ])
            ], -1)),
            _createElementVNode("div", { class: "wrap_flex" }, [
              _createElementVNode("div", {
                class: "card",
                onClick: goToTalentCE,
                style: {"max-width":"300px"}
              }, _cache[82] || (_cache[82] = [
                _createElementVNode("div", { class: "card-body" }, [
                  _createElementVNode("h3", null, "어린이 놀이공원 건립"),
                  _createElementVNode("br"),
                  _createElementVNode("br"),
                  _createElementVNode("img", {
                    src: _imports_17,
                    class: "icon"
                  }),
                  _createElementVNode("br"),
                  _createElementVNode("br"),
                  _createElementVNode("p", null, "Activity_재능탐색_초등학생")
                ], -1)
              ])),
              _createElementVNode("div", {
                class: "card",
                onClick: goToTalentCM,
                style: {"max-width":"300px"}
              }, _cache[83] || (_cache[83] = [
                _createElementVNode("div", { class: "card-body" }, [
                  _createElementVNode("h3", null, "청소년문화공간 건립"),
                  _createElementVNode("br"),
                  _createElementVNode("br"),
                  _createElementVNode("img", {
                    src: _imports_18,
                    class: "icon"
                  }),
                  _createElementVNode("br"),
                  _createElementVNode("br"),
                  _createElementVNode("p", null, "Activity_진로탐색_중학생")
                ], -1)
              ])),
              _createElementVNode("div", {
                class: "card",
                onClick: goToTalentCH,
                style: {"max-width":"300px"}
              }, _cache[84] || (_cache[84] = [
                _createElementVNode("div", { class: "card-body" }, [
                  _createElementVNode("h3", null, "미래 도시 건립"),
                  _createElementVNode("br"),
                  _createElementVNode("br"),
                  _createElementVNode("img", {
                    src: _imports_19,
                    class: "icon"
                  }),
                  _createElementVNode("br"),
                  _createElementVNode("br"),
                  _createElementVNode("p", null, "Activity_전공탐색_고등학생")
                ], -1)
              ])),
              _createElementVNode("div", {
                class: "card",
                onClick: goToTalentCU,
                style: {"max-width":"300px"}
              }, _cache[85] || (_cache[85] = [
                _createElementVNode("div", { class: "card-body" }, [
                  _createElementVNode("h3", null, "미래 작업공간 건립"),
                  _createElementVNode("br"),
                  _createElementVNode("br"),
                  _createElementVNode("img", {
                    src: _imports_20,
                    class: "icon"
                  }),
                  _createElementVNode("br"),
                  _createElementVNode("br"),
                  _createElementVNode("p", null, "Activity_직업탐색_대학생")
                ], -1)
              ]))
            ])
          ])
        ])
      ]),
      _createElementVNode("div", {
        class: "mblock_06",
        style: {"padding":"50px 10px"}
      }, [
        _cache[92] || (_cache[92] = _createElementVNode("h1", null, "꿈 · 창업 프로젝트", -1)),
        _createElementVNode("div", {
          class: "wrap_flex",
          style: {"padding-top":"15px"}
        }, [
          _createElementVNode("div", { style: {"width":"100%","max-width":"1300px"} }, [
            _cache[91] || (_cache[91] = _createElementVNode("div", {
              class: "card-header",
              style: {"text-align":"center","margin-bottom":"15px","font-size":"16px"}
            }, [
              _createElementVNode("span", null, [
                _createTextVNode("꿈·창업 프로젝트는 꿈을 실현하는 경험을 지원하는데 목표를 둡니다."),
                _createElementVNode("br"),
                _createTextVNode(" 꿈 · 창업 프로젝트는 학생이 자아 발견 과정을 통해 꿈을 명확하게 하여 그 꿈을 실현할 가상의 세상을 만드는 과정입니다.")
              ])
            ], -1)),
            _createElementVNode("div", { class: "wrap_flex" }, [
              _createElementVNode("div", {
                class: "card",
                onClick: goToStartUpCE,
                style: {"max-width":"300px"}
              }, _cache[88] || (_cache[88] = [
                _createElementVNode("div", { class: "card-body" }, [
                  _createElementVNode("h3", null, "재능발견으로 꿈·창업"),
                  _createElementVNode("br"),
                  _createElementVNode("br"),
                  _createElementVNode("img", {
                    src: _imports_21,
                    class: "icon"
                  }),
                  _createElementVNode("br"),
                  _createElementVNode("br"),
                  _createElementVNode("p", null, "Activity_꿈·창업_초등학생")
                ], -1)
              ])),
              _createElementVNode("div", {
                class: "card",
                onClick: goToStartUpCM,
                style: {"max-width":"300px"}
              }, _cache[89] || (_cache[89] = [
                _createElementVNode("div", { class: "card-body" }, [
                  _createElementVNode("h3", null, "재능발휘로 꿈·창업"),
                  _createElementVNode("br"),
                  _createElementVNode("br"),
                  _createElementVNode("img", {
                    src: _imports_22,
                    class: "icon"
                  }),
                  _createElementVNode("br"),
                  _createElementVNode("br"),
                  _createElementVNode("p", null, "Activity_ 꿈·창업_중학생")
                ], -1)
              ])),
              _createElementVNode("div", {
                class: "card",
                onClick: goToStartUpCH,
                style: {"max-width":"300px"}
              }, _cache[90] || (_cache[90] = [
                _createElementVNode("div", { class: "card-body" }, [
                  _createElementVNode("h3", null, "재능디자인으로 꿈·창업"),
                  _createElementVNode("br"),
                  _createElementVNode("br"),
                  _createElementVNode("img", {
                    src: _imports_23,
                    class: "icon"
                  }),
                  _createElementVNode("br"),
                  _createElementVNode("br"),
                  _createElementVNode("p", null, "Activity_꿈·창업_ 고등학생")
                ], -1)
              ]))
            ])
          ])
        ])
      ]),
      _createElementVNode("div", {
        class: "mblock_06",
        style: {"padding":"50px 10px"}
      }, [
        _cache[98] || (_cache[98] = _createElementVNode("h1", null, "데이터 사이언스 체험 활동", -1)),
        _createElementVNode("div", {
          class: "wrap_flex",
          style: {"padding-top":"15px"}
        }, [
          _createElementVNode("div", { style: {"width":"100%","max-width":"1300px"} }, [
            _cache[97] || (_cache[97] = _createElementVNode("div", {
              class: "card-header",
              style: {"text-align":"center","margin-bottom":"15px","font-size":"16px"}
            }, [
              _createElementVNode("span", null, [
                _createTextVNode("데이터 사이언스 체험 활동은 재능검사 개발 및 분석 활동을 통해 자신의 재능을 이해, 진로 탐색함은 물론"),
                _createElementVNode("br"),
                _createTextVNode("인간행동을 측정, 분석, 예측함으로써 미래 문제를 데이터 기반 의사결정 하는 과정을 수행한다. ")
              ])
            ], -1)),
            _createElementVNode("div", { class: "wrap_flex" }, [
              _createElementVNode("div", {
                class: "card",
                onClick: goToCareerE,
                style: {"max-width":"300px"}
              }, _cache[93] || (_cache[93] = [
                _createElementVNode("div", { class: "card-body" }, [
                  _createElementVNode("h3", null, "인간행동 측정 및 예측"),
                  _createElementVNode("br"),
                  _createElementVNode("br"),
                  _createElementVNode("img", {
                    src: _imports_24,
                    class: "icon"
                  }),
                  _createElementVNode("br"),
                  _createElementVNode("br"),
                  _createElementVNode("p", null, "Activity_데이터사이언스_초등학생")
                ], -1)
              ])),
              _createElementVNode("div", {
                class: "card",
                onClick: goToCareerM,
                style: {"max-width":"300px"}
              }, _cache[94] || (_cache[94] = [
                _createElementVNode("div", { class: "card-body" }, [
                  _createElementVNode("h3", null, "인간행동 측정 및 예측"),
                  _createElementVNode("br"),
                  _createElementVNode("br"),
                  _createElementVNode("img", {
                    src: _imports_25,
                    class: "icon"
                  }),
                  _createElementVNode("br"),
                  _createElementVNode("br"),
                  _createElementVNode("p", null, "Activity_데이터사이언스_중학생")
                ], -1)
              ])),
              _createElementVNode("div", {
                class: "card",
                onClick: goToCareerH,
                style: {"max-width":"300px"}
              }, _cache[95] || (_cache[95] = [
                _createElementVNode("div", { class: "card-body" }, [
                  _createElementVNode("h3", null, "인간행동 측정 및 예측"),
                  _createElementVNode("br"),
                  _createElementVNode("br"),
                  _createElementVNode("img", {
                    src: _imports_26,
                    class: "icon"
                  }),
                  _createElementVNode("br"),
                  _createElementVNode("br"),
                  _createElementVNode("p", null, "Activity_데이터사이언스_고등학생")
                ], -1)
              ])),
              _createElementVNode("div", {
                class: "card",
                onClick: goToCareerU,
                style: {"max-width":"300px"}
              }, _cache[96] || (_cache[96] = [
                _createElementVNode("div", { class: "card-body" }, [
                  _createElementVNode("h3", null, "인간행동 측정 및 예측"),
                  _createElementVNode("br"),
                  _createElementVNode("br"),
                  _createElementVNode("img", {
                    src: _imports_27,
                    class: "icon"
                  }),
                  _createElementVNode("br"),
                  _createElementVNode("br"),
                  _createElementVNode("p", null, "Activity_데이터사이언스_대학생")
                ], -1)
              ]))
            ])
          ])
        ])
      ]),
      _createElementVNode("div", {
        class: "mblock_06",
        style: {"padding":"50px 10px"}
      }, [
        _cache[103] || (_cache[103] = _createElementVNode("h1", null, "성장-폴리오 프로젝트", -1)),
        _createElementVNode("div", {
          class: "wrap_flex",
          style: {"padding-top":"15px"}
        }, [
          _createElementVNode("div", { style: {"width":"100%","max-width":"1300px"} }, [
            _cache[102] || (_cache[102] = _createElementVNode("div", {
              class: "card-header",
              style: {"text-align":"center","margin-bottom":"15px","font-size":"16px"}
            }, [
              _createElementVNode("span", null, [
                _createTextVNode("PUTT2.0 기반 성장-폴리오 프로젝트는 학생이 자신의 크고 작은 경험을 발굴, 재해석하는 과정으로 이루어집니다."),
                _createElementVNode("br"),
                _createTextVNode(" 이 과정을 통해 학생은 자신의 경험을 새롭게 mapping, 디자인하는 과제를 수행합니다. ")
              ])
            ], -1)),
            _createElementVNode("div", { class: "wrap_flex" }, [
              _createElementVNode("div", {
                class: "card",
                onClick: goToGrowthM,
                style: {"max-width":"300px"}
              }, _cache[99] || (_cache[99] = [
                _createElementVNode("div", { class: "card-body" }, [
                  _createElementVNode("h3", null, "경험 - 자랑스런 나"),
                  _createElementVNode("br"),
                  _createElementVNode("br"),
                  _createElementVNode("img", {
                    src: _imports_28,
                    class: "icon"
                  }),
                  _createElementVNode("br"),
                  _createElementVNode("br"),
                  _createElementVNode("p", null, "Activity_성장폴리오_중학생")
                ], -1)
              ])),
              _createElementVNode("div", {
                class: "card",
                onClick: goToGrowthH,
                style: {"max-width":"300px"}
              }, _cache[100] || (_cache[100] = [
                _createElementVNode("div", { class: "card-body" }, [
                  _createElementVNode("h3", null, "경험 - 특별한 나"),
                  _createElementVNode("br"),
                  _createElementVNode("br"),
                  _createElementVNode("img", {
                    src: _imports_29,
                    class: "icon"
                  }),
                  _createElementVNode("br"),
                  _createElementVNode("br"),
                  _createElementVNode("p", null, "Activity_성장폴리오_고등학생")
                ], -1)
              ])),
              _createElementVNode("div", {
                class: "card",
                onClick: goToGrowthU,
                style: {"max-width":"300px"}
              }, _cache[101] || (_cache[101] = [
                _createElementVNode("div", { class: "card-body" }, [
                  _createElementVNode("h3", null, "경험 - 최고의 나"),
                  _createElementVNode("br"),
                  _createElementVNode("br"),
                  _createElementVNode("img", {
                    src: _imports_30,
                    class: "icon"
                  }),
                  _createElementVNode("br"),
                  _createElementVNode("br"),
                  _createElementVNode("p", null, "Activity_성장폴리오_대학생")
                ], -1)
              ]))
            ])
          ])
        ])
      ]),
      _createElementVNode("div", {
        class: "mblock_06",
        style: {"padding":"50px 10px"}
      }, [
        _cache[109] || (_cache[109] = _createElementVNode("h1", null, "전문가 과정", -1)),
        _createElementVNode("div", {
          class: "wrap_flex",
          style: {"padding-top":"15px"}
        }, [
          _createElementVNode("div", { style: {"width":"100%","max-width":"1300px"} }, [
            _cache[108] || (_cache[108] = _createElementVNode("div", {
              class: "card-header",
              style: {"text-align":"center","margin-bottom":"15px","font-size":"16px"}
            }, [
              _createElementVNode("span", null, [
                _createTextVNode("다중재능코칭 전문가 과정은 PUTT2.0 이해를 기반으로 결과 분석 및 해석, 상담코칭, 전문가 강의 등을 수행할 수 있는 역량 계발 과정입니다."),
                _createElementVNode("br"),
                _createTextVNode(" 다중재능코칭 전문가 교육은 초급과정, 고급과정, 최고과정으로 구성됩니다.")
              ])
            ], -1)),
            _createElementVNode("div", { class: "wrap_flex" }, [
              _createElementVNode("div", {
                class: "card",
                onClick: goToExpertE,
                style: {"max-width":"300px"}
              }, _cache[104] || (_cache[104] = [
                _createElementVNode("div", { class: "card-body" }, [
                  _createElementVNode("h3", null, "검사 이해·결과 분석"),
                  _createElementVNode("br"),
                  _createElementVNode("br"),
                  _createElementVNode("img", {
                    src: _imports_31,
                    class: "icon"
                  }),
                  _createElementVNode("br"),
                  _createElementVNode("br"),
                  _createElementVNode("p", null, "다중재능코칭_전문가_초급과정")
                ], -1)
              ])),
              _createElementVNode("div", {
                class: "card",
                onClick: goToExpertH,
                style: {"max-width":"300px"}
              }, _cache[105] || (_cache[105] = [
                _createElementVNode("div", { class: "card-body" }, [
                  _createElementVNode("h3", null, "철학·개념모델 이해"),
                  _createElementVNode("br"),
                  _createElementVNode("br"),
                  _createElementVNode("img", {
                    src: _imports_32,
                    class: "icon"
                  }),
                  _createElementVNode("br"),
                  _createElementVNode("br"),
                  _createElementVNode("p", null, "다중재능코칭_전문가_고급과정")
                ], -1)
              ])),
              _createElementVNode("div", {
                class: "card",
                onClick: goToExpertB,
                style: {"max-width":"300px"}
              }, _cache[106] || (_cache[106] = [
                _createElementVNode("div", { class: "card-body" }, [
                  _createElementVNode("h3", null, "교수설계·강의역량 강화"),
                  _createElementVNode("br"),
                  _createElementVNode("br"),
                  _createElementVNode("img", {
                    src: _imports_33,
                    class: "icon"
                  }),
                  _createElementVNode("br"),
                  _createElementVNode("br"),
                  _createElementVNode("p", null, "다중재능코칭_전문가_최고과정")
                ], -1)
              ])),
              _createElementVNode("div", {
                class: "card",
                onClick: goToExpertP,
                style: {"max-width":"300px"}
              }, _cache[107] || (_cache[107] = [
                _createElementVNode("div", { class: "card-body" }, [
                  _createElementVNode("h3", null, "경험 – 미래 창조"),
                  _createElementVNode("br"),
                  _createElementVNode("br"),
                  _createElementVNode("img", {
                    src: _imports_34,
                    class: "icon"
                  }),
                  _createElementVNode("br"),
                  _createElementVNode("br"),
                  _createElementVNode("p", null, "교육_성장폴리오_전문가 과정")
                ], -1)
              ]))
            ])
          ])
        ])
      ]),
      _cache[110] || (_cache[110] = _createStaticVNode("<div class=\"mblock_06\" data-v-ec70352a><h1 data-v-ec70352a>다중재능코칭 전문가 자격증 배지</h1><div class=\"wrap_flex\" style=\"padding-top:15px;\" data-v-ec70352a><div style=\"width:100%;max-width:700px;\" data-v-ec70352a><div class=\"card-header\" style=\"text-align:center;margin-bottom:15px;font-size:16px;\" data-v-ec70352a><span data-v-ec70352a>다중재능코칭 전문가 교육-고급과정 이수자에게는 다중재능코칭 전문가 2급 자격증을,<br data-v-ec70352a> 다중재능코칭 전문가 교육- 최고과정 이수자에게는 다중재능코칭 전문가 1급 자격증을 부여합니다.</span></div><div class=\"card\" style=\"cursor:default;max-width:700px;\" data-v-ec70352a><div class=\"card-body\" data-v-ec70352a><h3 data-v-ec70352a>다중재능상담코칭 전문가 자격 관리</h3><br data-v-ec70352a><img src=\"" + _imports_35 + "\" class=\"icon\" data-v-ec70352a><br data-v-ec70352a><p data-v-ec70352a>초급과정 · 고급과정 · 최고과정</p></div></div></div></div></div>", 1))
    ]),
    _createVNode(_unref(carousel), {
      dots: false,
      autoplay: true,
      nav: false,
      responsive: { 0: { items: 1 }, 768: { items: 4 } },
      id: "owl_partner",
      class: "carousel pm-banner_slide_responsive_partner"
    }, {
      default: _withCtx(() => _cache[111] || (_cache[111] = [
        _createElementVNode("div", { class: "item" }, [
          _createElementVNode("a", {
            href: "https://www.ggoomgil.go.kr/front/index.do",
            target: "_blank"
          }, [
            _createElementVNode("img", {
              src: _imports_36,
              alt: "꿈길"
            })
          ])
        ], -1),
        _createElementVNode("div", { class: "item" }, [
          _createElementVNode("a", {
            href: "https://jinroad.or.kr/",
            target: "_blank"
          }, [
            _createElementVNode("img", {
              src: _imports_37,
              alt: "진로路"
            })
          ])
        ], -1),
        _createElementVNode("div", { class: "item" }, [
          _createElementVNode("a", {
            href: "https://www.pqi.or.kr/indexMain.do",
            target: "_blank"
          }, [
            _createElementVNode("img", {
              src: _imports_38,
              alt: "PQI"
            })
          ])
        ], -1),
        _createElementVNode("div", { class: "item" }, [
          _createElementVNode("a", {
            href: "https://www.moe.go.kr/main.do?s=moe",
            target: "_blank"
          }, [
            _createElementVNode("img", {
              src: _imports_39,
              alt: "교육부"
            })
          ])
        ], -1)
      ])),
      _: 1
    }),
    _cache[112] || (_cache[112] = _createStaticVNode("<div id=\"owl_partner\" class=\"owl-carousel pm-banner_slide_responsive_partner\" data-v-ec70352a><div class=\"item\" data-v-ec70352a><a href=\"https://www.ggoomgil.go.kr/front/index.do\" target=\"_blank\" data-v-ec70352a><img src=\"" + _imports_36 + "\" alt=\"꿈길\" data-v-ec70352a></a></div><div class=\"item\" data-v-ec70352a><a href=\"https://jinroad.or.kr/\" target=\"_blank\" data-v-ec70352a><img src=\"" + _imports_37 + "\" alt=\"진로路\" data-v-ec70352a></a></div><div class=\"item\" data-v-ec70352a><a href=\"https://www.pqi.or.kr/indexMain.do\" target=\"_blank\" data-v-ec70352a><img src=\"" + _imports_38 + "\" alt=\"PQI\" data-v-ec70352a></a></div><div class=\"item\" data-v-ec70352a><a href=\"https://www.moe.go.kr/main.do?s=moe\" target=\"_blank\" data-v-ec70352a><img src=\"" + _imports_39 + "\" alt=\"교육부\" data-v-ec70352a></a></div></div>", 1))
  ]))
}
}

})